module.exports = __webpack_public_path__ + "static/media/profileCircleFinvaro.b5ccafe2.svg";